import { render, staticRenderFns } from "./IBranch.vue?vue&type=template&id=14810f73&"
import script from "./IBranch.vue?vue&type=script&lang=ts&"
export * from "./IBranch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports